import queryActionFactory from 'common/actions/queryActionFactory';
import { userLoaded } from 'common/actions/users';
import DataV2 from 'common/DataV2';

import type { CompanyUser } from 'common/api/endpoints/users';
import type { Dispatch } from 'redux-connect';

export type QueryParams = {
  limit?: number;
  search?: string;
  thirdPartyCompanyID: string;
};

export const {
  getQueryKey: getUsersForCompanyQueryKey,
  invalidateQueries: invalidateUsersForCompanyQueries,
  loadQuery,
  loadMore,
  reloadQuery: reloadUsersForCompanyQuery,
  BulkLoadedType,
  BulkRemoveType,
  ErrorType,
  InvalidateType,
  LoadedMoreType,
  LoadedType,
  RequestMoreType,
  RequestType,
} = queryActionFactory<CompanyUser, QueryParams>(
  'usersForCompanyQueries',
  DataV2.queries.usersForCompany,
  {
    onItemsLoaded: async (dispatch: Dispatch, items: CompanyUser[]) => {
      items.forEach((user) => {
        dispatch(userLoaded(user.urlName, user));
      });
    },
  },
);

export const loadUsersForCompanyQuery = loadQuery;
export const loadMoreUsersForCompanyQuery = loadMore;
